/* eslint-disable camelcase */
import moment from 'moment';
import utilsApi from '../api/posts/UtilsApi';
/*
 * Metodo que genera el payload para solicitar los permalinks de
 */
const generatePermalink = async ({
  adults,
  arrival_date,
  departure_date,
  destination,
  destination_id,
  hotel_code,
  hotel_name,
  iataId,
  isRound,
  mapping_id,
  mapping_type,
  origin_id,
  promo_code,
  provider,
  token,
  youngs,
}) => {
  // TODO - Instead of generete permalink here we should use new utility
  const data = {
    offer_type: 'simple',
    provider,
    departure: iataId,
    departure_date: moment(departure_date).toISOString(),
    destination,
    promo_code,
    destination_id,
    origin_id,
    adults,
    youngs,
  };
  if (provider === 'bestday') {
    data.best_day_hotel = parseInt(hotel_code, 10);
    data.hotel_name = hotel_name;
  }
  if (provider === 'pricetravel') {
    data.mapping_id = mapping_id;
    data.mapping_type = mapping_type;
    data.destination_id = hotel_code;
  }
  if (isRound) {
    data.arrival_date = moment(arrival_date).toISOString();
  }
  const result = await utilsApi.providerPermalink(data, token);
  return result;
};
export default generatePermalink;
